import React from "react";
import { Box, Fade } from "@mui/material";
import { styled } from "@mui/system";

const LoaderContainer = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  zIndex: 1000
}));

const BubbleContainer = styled(Box)({
  display: "flex",
  gap: "8px"
});

const Bubble = styled(Box)({
  width: "12px",
  height: "12px",
  backgroundColor: "#3f51b5",
  borderRadius: "50%",
  animation: "bounce 1.5s infinite ease-in-out",
  "@keyframes bounce": {
    "0%, 100%": {
      transform: "translateY(0)"
    },
    "50%": {
      transform: "translateY(-10px)"
    }
  }
});

const ChatLoader = ({ size = "medium", text = "Loading ...", color = "#3f51b5" }) => {
  return (
    <Fade in={true} timeout={800}>
      <LoaderContainer>
        <BubbleContainer>
          {[0, 1, 2].map((index) => (
            <Bubble
              key={index}
              sx={{
                backgroundColor: color,
                animationDelay: `${index * 0.2}s`
              }}
            />
          ))}
        </BubbleContainer>
      </LoaderContainer>
    </Fade>
  );
};

export default ChatLoader;
